'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M7.32 12.066v.674H3.605v7.586h5.322v-5.702h.673v5.702h11.195v-5.702h.674v6.04a.337.337 0 0 1-.27.33l-.067.006H3.267a.337.337 0 0 1-.33-.269l-.007-.068v-8.26c0-.163.116-.299.269-.33l.068-.007H7.32Zm8.213 2.558v5.029h-.674v-5.029h.674Zm-7.996 1.367c.186 0 .337.151.337.336v2.703a.337.337 0 0 1-.337.337H4.992a.337.337 0 0 1-.337-.337v-2.703c0-.185.151-.336.337-.336h2.545Zm-.336.673H5.329v2.029h1.872v-2.029Zm9.343-.57a.337.337 0 1 1 0 .674.337.337 0 0 1 0-.674Zm-2.695 0a.337.337 0 1 1 0 .674.337.337 0 0 1 0-.674Zm-5.975-1.451v.674H4.655v-.674h3.219Zm-.337-1.347a.337.337 0 1 1 0 .675.337.337 0 0 1 0-.675Zm-1.272 0a.337.337 0 1 1 0 .675.337.337 0 0 1 0-.675Zm-1.273 0a.337.337 0 1 1 0 .675.337.337 0 0 1 0-.675ZM7.082 3c.186 0 .337.15.337.337v1.597l1.602 1.65h1.172c.186 0 .337.15.337.337v1.938a.337.337 0 0 1-.337.337H2.337A.337.337 0 0 1 2 8.859V6.92c0-.186.151-.337.337-.337h1.172l1.601-1.65V3.337c0-.186.151-.337.337-.337Zm14.049 0c.186 0 .336.151.336.337v5.521c0 .186-.15.337-.336.337H11.54a.337.337 0 0 1-.337-.337V3.337c0-.186.151-.337.337-.337h9.591Zm-.337.674h-8.917v4.848h8.917V3.674ZM6.939 5.408H5.59L4.447 6.584h1.818v.674H2.673v1.264h7.183V7.258H7.275v-.674h.807L6.939 5.408Zm10.062-1.061v3.501h-.674V4.347h.674Zm1.01 1.312a.337.337 0 1 1 0 .674.337.337 0 0 1 0-.674Zm-2.694 0a.337.337 0 1 1 0 .674.337.337 0 0 1 0-.674ZM6.745 3.674h-.961v1.06h.961v-1.06Z",
    fill: "#3F3E4B"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m19.808 9.736.549 1.113a.168.168 0 0 0 .126.091l1.228.18c.137.02.192.188.093.284l-.89.866a.17.17 0 0 0-.047.15l.21 1.222a.167.167 0 0 1-.243.176l-1.098-.577a.166.166 0 0 0-.156 0l-1.098.577a.168.168 0 0 1-.244-.176l.21-1.223a.165.165 0 0 0-.048-.149l-.888-.866a.167.167 0 0 1 .092-.285l1.228-.179a.166.166 0 0 0 .126-.09l.549-1.114a.168.168 0 0 1 .3 0Zm-4.708 0 .55 1.113a.168.168 0 0 0 .125.091l1.228.18c.137.02.192.188.093.284l-.889.866a.17.17 0 0 0-.048.15l.21 1.222a.167.167 0 0 1-.243.176l-1.098-.577a.166.166 0 0 0-.156 0l-1.098.577a.168.168 0 0 1-.244-.176l.21-1.223a.168.168 0 0 0-.048-.149l-.888-.866a.167.167 0 0 1 .092-.285l1.228-.179a.166.166 0 0 0 .126-.09l.55-1.114a.168.168 0 0 1 .3 0Zm-4.646 0 .55 1.113a.17.17 0 0 0 .125.091l1.228.18c.137.02.192.188.093.284l-.889.866a.17.17 0 0 0-.048.15l.21 1.222a.167.167 0 0 1-.243.176l-1.098-.577a.166.166 0 0 0-.156 0l-1.098.577a.168.168 0 0 1-.244-.176l.21-1.223a.165.165 0 0 0-.048-.149l-.888-.866a.167.167 0 0 1 .092-.285l1.228-.179a.166.166 0 0 0 .126-.09l.55-1.114a.168.168 0 0 1 .3 0Z",
    fill: "currentColor"
  })));
});
var FwSet0KitchenNew = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.FwSet0KitchenNew = FwSet0KitchenNew;